var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "main",
    { ref: "main", staticClass: "config" },
    [
      _c("ConfigHeadbar", { ref: "head" }),
      _vm._v(" "),
      _c(
        "section",
        { staticClass: "config-wrapper" },
        [
          _c(
            "div",
            { staticClass: "container" },
            [
              _c(
                "transition",
                {
                  attrs: { name: _vm.transitype },
                  on: { "after-enter": _vm.onAfterEnter, css: false },
                },
                [
                  _c(
                    "keep-alive",
                    { attrs: { max: "7" } },
                    [
                      _c("router-view", {
                        ref: "view",
                        class: { fxd: _vm.calcH != "none" },
                        style: { "max-height": _vm.calcH },
                        on: { newFont: _vm.fontUpdate },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c("transition", { attrs: { name: "bee" } }, [
                _c(
                  "div",
                  {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value: _vm.Global.currentConfigStep == 6,
                        expression: "Global.currentConfigStep == 6",
                      },
                    ],
                    staticClass: "bee-payment",
                  },
                  [
                    _c("div", { staticClass: "hex-wrapper" }, [
                      _c("div", { staticClass: "col" }, [
                        _c("div", { staticClass: "hex" }),
                        _vm._v(" "),
                        _c("div", { staticClass: "hex" }, [
                          _c(
                            "svg",
                            {
                              attrs: {
                                width: "204",
                                height: "185",
                                viewBox: "0 0 204 185",
                              },
                            },
                            [
                              _c("path", {
                                attrs: {
                                  opacity: ".03",
                                  d: "M192.657 65.3865C199.402 77.068 202.774 82.9088 203.44 89.2506C203.659 91.3354 203.659 93.4375 203.44 95.5223C202.774 101.864 199.402 107.705 192.657 119.386L170.63 157.538C163.886 169.22 160.514 175.061 155.355 178.809C153.659 180.041 151.838 181.092 149.923 181.945C144.098 184.538 137.353 184.538 123.865 184.538L79.8106 184.538C66.3219 184.538 59.5775 184.538 53.7521 181.945C51.837 181.092 50.0166 180.041 48.3206 178.809C43.1618 175.061 39.7896 169.22 33.0452 157.538L11.0182 119.386C4.2738 107.705 0.901622 101.864 0.235072 95.5223C0.015956 93.4375 0.0159561 91.3354 0.235072 89.2506C0.901622 82.9088 4.2738 77.068 11.0182 65.3865L33.0452 27.2345C39.7896 15.5529 43.1618 9.71208 48.3206 5.96396C50.0166 4.73178 51.837 3.68075 53.7521 2.8281C59.5775 0.234468 66.3219 0.234468 79.8106 0.234469L123.865 0.23447C137.353 0.234471 144.098 0.234471 149.923 2.82811C151.838 3.68076 153.659 4.73178 155.355 5.96396C160.514 9.71209 163.886 15.5529 170.63 27.2345L192.657 65.3865Z",
                                  fill: "url(#grt)",
                                },
                              }),
                              _vm._v(" "),
                              _c(
                                "defs",
                                [
                                  _c(
                                    "linearGradient",
                                    {
                                      attrs: {
                                        id: "grt",
                                        x1: "168.52",
                                        y1: "175.385",
                                        x2: "13.5029",
                                        y2: "144.083",
                                        gradientUnits: "userSpaceOnUse",
                                      },
                                    },
                                    [
                                      _c("stop", {
                                        attrs: { "stop-color": "#F3CA54" },
                                      }),
                                      _vm._v(" "),
                                      _c("stop", {
                                        attrs: {
                                          offset: "1",
                                          "stop-color": "#FFBB36",
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                            ]
                          ),
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "hex" }, [
                          _c(
                            "svg",
                            {
                              attrs: {
                                width: "204",
                                height: "185",
                                viewBox: "0 0 204 185",
                              },
                            },
                            [
                              _c("path", {
                                attrs: {
                                  opacity: ".05",
                                  d: "M192.657 65.3865C199.402 77.068 202.774 82.9088 203.44 89.2506C203.659 91.3354 203.659 93.4375 203.44 95.5223C202.774 101.864 199.402 107.705 192.657 119.386L170.63 157.538C163.886 169.22 160.514 175.061 155.355 178.809C153.659 180.041 151.838 181.092 149.923 181.945C144.098 184.538 137.353 184.538 123.865 184.538L79.8106 184.538C66.3219 184.538 59.5775 184.538 53.7521 181.945C51.837 181.092 50.0166 180.041 48.3206 178.809C43.1618 175.061 39.7896 169.22 33.0452 157.538L11.0182 119.386C4.2738 107.705 0.901622 101.864 0.235072 95.5223C0.015956 93.4375 0.0159561 91.3354 0.235072 89.2506C0.901622 82.9088 4.2738 77.068 11.0182 65.3865L33.0452 27.2345C39.7896 15.5529 43.1618 9.71208 48.3206 5.96396C50.0166 4.73178 51.837 3.68075 53.7521 2.8281C59.5775 0.234468 66.3219 0.234468 79.8106 0.234469L123.865 0.23447C137.353 0.234471 144.098 0.234471 149.923 2.82811C151.838 3.68076 153.659 4.73178 155.355 5.96396C160.514 9.71209 163.886 15.5529 170.63 27.2345L192.657 65.3865Z",
                                  fill: "url(#grt)",
                                },
                              }),
                            ]
                          ),
                        ]),
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "col" }, [
                        _c("div", { staticClass: "hex" }),
                        _vm._v(" "),
                        _c("div", { staticClass: "hex" }),
                        _vm._v(" "),
                        _c("div", { staticClass: "hex" }),
                        _vm._v(" "),
                        _c("div", { staticClass: "hex" }, [
                          _c(
                            "svg",
                            {
                              attrs: {
                                width: "204",
                                height: "185",
                                viewBox: "0 0 204 185",
                              },
                            },
                            [
                              _c("path", {
                                attrs: {
                                  opacity: ".05",
                                  d: "M192.657 65.3865C199.402 77.068 202.774 82.9088 203.44 89.2506C203.659 91.3354 203.659 93.4375 203.44 95.5223C202.774 101.864 199.402 107.705 192.657 119.386L170.63 157.538C163.886 169.22 160.514 175.061 155.355 178.809C153.659 180.041 151.838 181.092 149.923 181.945C144.098 184.538 137.353 184.538 123.865 184.538L79.8106 184.538C66.3219 184.538 59.5775 184.538 53.7521 181.945C51.837 181.092 50.0166 180.041 48.3206 178.809C43.1618 175.061 39.7896 169.22 33.0452 157.538L11.0182 119.386C4.2738 107.705 0.901622 101.864 0.235072 95.5223C0.015956 93.4375 0.0159561 91.3354 0.235072 89.2506C0.901622 82.9088 4.2738 77.068 11.0182 65.3865L33.0452 27.2345C39.7896 15.5529 43.1618 9.71208 48.3206 5.96396C50.0166 4.73178 51.837 3.68075 53.7521 2.8281C59.5775 0.234468 66.3219 0.234468 79.8106 0.234469L123.865 0.23447C137.353 0.234471 144.098 0.234471 149.923 2.82811C151.838 3.68076 153.659 4.73178 155.355 5.96396C160.514 9.71209 163.886 15.5529 170.63 27.2345L192.657 65.3865Z",
                                  fill: "url(#grt)",
                                },
                              }),
                            ]
                          ),
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "hex" }),
                        _vm._v(" "),
                        _c("div", { staticClass: "hex" }, [
                          _c(
                            "svg",
                            {
                              attrs: {
                                width: "204",
                                height: "185",
                                viewBox: "0 0 204 185",
                              },
                            },
                            [
                              _c("path", {
                                attrs: {
                                  opacity: ".03",
                                  d: "M192.657 65.3865C199.402 77.068 202.774 82.9088 203.44 89.2506C203.659 91.3354 203.659 93.4375 203.44 95.5223C202.774 101.864 199.402 107.705 192.657 119.386L170.63 157.538C163.886 169.22 160.514 175.061 155.355 178.809C153.659 180.041 151.838 181.092 149.923 181.945C144.098 184.538 137.353 184.538 123.865 184.538L79.8106 184.538C66.3219 184.538 59.5775 184.538 53.7521 181.945C51.837 181.092 50.0166 180.041 48.3206 178.809C43.1618 175.061 39.7896 169.22 33.0452 157.538L11.0182 119.386C4.2738 107.705 0.901622 101.864 0.235072 95.5223C0.015956 93.4375 0.0159561 91.3354 0.235072 89.2506C0.901622 82.9088 4.2738 77.068 11.0182 65.3865L33.0452 27.2345C39.7896 15.5529 43.1618 9.71208 48.3206 5.96396C50.0166 4.73178 51.837 3.68075 53.7521 2.8281C59.5775 0.234468 66.3219 0.234468 79.8106 0.234469L123.865 0.23447C137.353 0.234471 144.098 0.234471 149.923 2.82811C151.838 3.68076 153.659 4.73178 155.355 5.96396C160.514 9.71209 163.886 15.5529 170.63 27.2345L192.657 65.3865Z",
                                  fill: "url(#grt)",
                                },
                              }),
                            ]
                          ),
                        ]),
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "col" }, [
                        _c("div", { staticClass: "hex" }, [
                          _c(
                            "svg",
                            {
                              attrs: {
                                width: "204",
                                height: "185",
                                viewBox: "0 0 204 185",
                              },
                            },
                            [
                              _c("path", {
                                attrs: {
                                  opacity: ".03",
                                  d: "M192.657 65.3865C199.402 77.068 202.774 82.9088 203.44 89.2506C203.659 91.3354 203.659 93.4375 203.44 95.5223C202.774 101.864 199.402 107.705 192.657 119.386L170.63 157.538C163.886 169.22 160.514 175.061 155.355 178.809C153.659 180.041 151.838 181.092 149.923 181.945C144.098 184.538 137.353 184.538 123.865 184.538L79.8106 184.538C66.3219 184.538 59.5775 184.538 53.7521 181.945C51.837 181.092 50.0166 180.041 48.3206 178.809C43.1618 175.061 39.7896 169.22 33.0452 157.538L11.0182 119.386C4.2738 107.705 0.901622 101.864 0.235072 95.5223C0.015956 93.4375 0.0159561 91.3354 0.235072 89.2506C0.901622 82.9088 4.2738 77.068 11.0182 65.3865L33.0452 27.2345C39.7896 15.5529 43.1618 9.71208 48.3206 5.96396C50.0166 4.73178 51.837 3.68075 53.7521 2.8281C59.5775 0.234468 66.3219 0.234468 79.8106 0.234469L123.865 0.23447C137.353 0.234471 144.098 0.234471 149.923 2.82811C151.838 3.68076 153.659 4.73178 155.355 5.96396C160.514 9.71209 163.886 15.5529 170.63 27.2345L192.657 65.3865Z",
                                  fill: "url(#grt)",
                                },
                              }),
                            ]
                          ),
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "hex" }, [
                          _c(
                            "svg",
                            {
                              attrs: {
                                width: "204",
                                height: "185",
                                viewBox: "0 0 204 185",
                              },
                            },
                            [
                              _c("path", {
                                attrs: {
                                  opacity: ".1",
                                  d: "M192.657 65.3865C199.402 77.068 202.774 82.9088 203.44 89.2506C203.659 91.3354 203.659 93.4375 203.44 95.5223C202.774 101.864 199.402 107.705 192.657 119.386L170.63 157.538C163.886 169.22 160.514 175.061 155.355 178.809C153.659 180.041 151.838 181.092 149.923 181.945C144.098 184.538 137.353 184.538 123.865 184.538L79.8106 184.538C66.3219 184.538 59.5775 184.538 53.7521 181.945C51.837 181.092 50.0166 180.041 48.3206 178.809C43.1618 175.061 39.7896 169.22 33.0452 157.538L11.0182 119.386C4.2738 107.705 0.901622 101.864 0.235072 95.5223C0.015956 93.4375 0.0159561 91.3354 0.235072 89.2506C0.901622 82.9088 4.2738 77.068 11.0182 65.3865L33.0452 27.2345C39.7896 15.5529 43.1618 9.71208 48.3206 5.96396C50.0166 4.73178 51.837 3.68075 53.7521 2.8281C59.5775 0.234468 66.3219 0.234468 79.8106 0.234469L123.865 0.23447C137.353 0.234471 144.098 0.234471 149.923 2.82811C151.838 3.68076 153.659 4.73178 155.355 5.96396C160.514 9.71209 163.886 15.5529 170.63 27.2345L192.657 65.3865Z",
                                  fill: "#fff",
                                },
                              }),
                            ]
                          ),
                          _vm._v(" "),
                          _vm.Global.mockupConfig.pictures.logo
                            ? _c("div", { staticClass: "in w-img" }, [
                                _c("img", {
                                  attrs: {
                                    src: _vm.Global.mockupConfig.pictures.logo,
                                    alt: "brand logo",
                                  },
                                }),
                              ])
                            : _vm._e(),
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "hex" }, [
                          _c(
                            "svg",
                            {
                              attrs: {
                                width: "204",
                                height: "185",
                                viewBox: "0 0 204 185",
                              },
                            },
                            [
                              _c("path", {
                                attrs: {
                                  opacity: ".06",
                                  d: "M192.657 65.3865C199.402 77.068 202.774 82.9088 203.44 89.2506C203.659 91.3354 203.659 93.4375 203.44 95.5223C202.774 101.864 199.402 107.705 192.657 119.386L170.63 157.538C163.886 169.22 160.514 175.061 155.355 178.809C153.659 180.041 151.838 181.092 149.923 181.945C144.098 184.538 137.353 184.538 123.865 184.538L79.8106 184.538C66.3219 184.538 59.5775 184.538 53.7521 181.945C51.837 181.092 50.0166 180.041 48.3206 178.809C43.1618 175.061 39.7896 169.22 33.0452 157.538L11.0182 119.386C4.2738 107.705 0.901622 101.864 0.235072 95.5223C0.015956 93.4375 0.0159561 91.3354 0.235072 89.2506C0.901622 82.9088 4.2738 77.068 11.0182 65.3865L33.0452 27.2345C39.7896 15.5529 43.1618 9.71208 48.3206 5.96396C50.0166 4.73178 51.837 3.68075 53.7521 2.8281C59.5775 0.234468 66.3219 0.234468 79.8106 0.234469L123.865 0.23447C137.353 0.234471 144.098 0.234471 149.923 2.82811C151.838 3.68076 153.659 4.73178 155.355 5.96396C160.514 9.71209 163.886 15.5529 170.63 27.2345L192.657 65.3865Z",
                                  fill: "url(#grt)",
                                },
                              }),
                            ]
                          ),
                        ]),
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "col" }, [
                        _c("div", { staticClass: "hex" }),
                        _vm._v(" "),
                        _c("div", { staticClass: "hex" }),
                        _vm._v(" "),
                        _c("div", { staticClass: "hex" }, [
                          _c(
                            "svg",
                            {
                              attrs: {
                                width: "204",
                                height: "185",
                                viewBox: "0 0 204 185",
                              },
                            },
                            [
                              _c("path", {
                                attrs: {
                                  d: "M192.657 65.3865C199.402 77.068 202.774 82.9088 203.44 89.2506C203.659 91.3354 203.659 93.4375 203.44 95.5223C202.774 101.864 199.402 107.705 192.657 119.386L170.63 157.538C163.886 169.22 160.514 175.061 155.355 178.809C153.659 180.041 151.838 181.092 149.923 181.945C144.098 184.538 137.353 184.538 123.865 184.538L79.8106 184.538C66.3219 184.538 59.5775 184.538 53.7521 181.945C51.837 181.092 50.0166 180.041 48.3206 178.809C43.1618 175.061 39.7896 169.22 33.0452 157.538L11.0182 119.386C4.2738 107.705 0.901622 101.864 0.235072 95.5223C0.015956 93.4375 0.0159561 91.3354 0.235072 89.2506C0.901622 82.9088 4.2738 77.068 11.0182 65.3865L33.0452 27.2345C39.7896 15.5529 43.1618 9.71208 48.3206 5.96396C50.0166 4.73178 51.837 3.68075 53.7521 2.8281C59.5775 0.234468 66.3219 0.234468 79.8106 0.234469L123.865 0.23447C137.353 0.234471 144.098 0.234471 149.923 2.82811C151.838 3.68076 153.659 4.73178 155.355 5.96396C160.514 9.71209 163.886 15.5529 170.63 27.2345L192.657 65.3865Z",
                                  fill: "url(#grt)",
                                },
                              }),
                            ]
                          ),
                          _vm._v(" "),
                          _c("div", { staticClass: "in" }, [
                            _c(
                              "svg",
                              {
                                attrs: {
                                  width: "90",
                                  height: "91",
                                  viewBox: "0 0 90 91",
                                  fill: "none",
                                },
                              },
                              [
                                _c("path", {
                                  attrs: {
                                    "fill-rule": "evenodd",
                                    "clip-rule": "evenodd",
                                    d: "M58.2681 21.7235L44.8801 35.9149L31.1386 21.3417C30.4951 20.6556 30.2548 19.6875 30.4981 18.7837C30.5881 16.8968 31.0503 15.0472 31.856 13.3418L23.4584 4.91484C23.4285 4.88629 23.3998 4.85745 23.3713 4.82738C22.3402 3.74377 22.3818 2.02948 23.4653 0.997566M58.2681 21.7235C59.0049 21.2094 59.4395 20.3594 59.4206 19.4564C59.4188 17.3184 58.9385 15.2103 58.0175 13.2854L66.4006 4.90229L66.4069 4.89564C67.4388 3.81199 67.3973 2.09704 66.3134 1.06493C65.267 0.068628 63.6226 0.0686052 62.5762 1.06491L62.5696 1.07125L54.7697 8.87113C49.2484 3.75313 40.6634 3.7385 35.1234 8.91205L27.2893 1.08363C26.2566 0.00697649 24.5461 -0.0321421 23.4653 0.997566M44.9611 10.4481C40.3235 10.4829 36.4769 14.0019 35.9999 18.5809L44.8802 28.0148L53.9266 18.403C53.3661 13.8927 49.5391 10.4695 44.9611 10.4481Z",
                                    fill: "#191818",
                                  },
                                }),
                                _vm._v(" "),
                                _c("path", {
                                  attrs: {
                                    "fill-rule": "evenodd",
                                    "clip-rule": "evenodd",
                                    d: "M63.6644 20.9348L85.0589 42.3354L85.1387 42.36L85.2704 42.4917C91.491 48.713 91.491 58.7999 85.2704 65.0212C79.0492 71.2424 68.9621 71.2424 62.7409 65.0212L60.9499 63.2302V68.8522C60.9499 76.508 57.3686 81.8841 53.7369 85.3562C50.1312 88.8034 46.4478 90.4048 46.0598 90.561L46.0553 90.5628L45.0224 90.9911L43.9742 90.5601L43.971 90.5587C43.6318 90.4174 39.9333 88.8186 36.3088 85.3564C32.6743 81.8846 29.0864 76.5085 29.0864 68.8522V63.2363L27.2954 65.0273C21.0655 71.2572 10.965 71.2572 4.73518 65.0273C1.90383 62.196 0.358808 58.5633 0.101414 54.8596L0.0996094 54.8337V52.6608L0.101414 52.6348C0.358808 48.9312 1.90383 45.2985 4.73518 42.4671L24.3554 22.8469L24.3621 22.8406C25.4085 21.8443 27.0528 21.8443 28.0992 22.8406C29.1831 23.8727 29.2246 25.5877 28.1927 26.6713L28.1864 26.678L8.57234 46.292C4.69406 50.357 4.69599 56.7533 8.57812 60.816C12.5887 65.0128 19.2405 65.166 23.4397 61.1595L41.1287 43.4705L35.6106 37.9523L16.6071 56.9557C16.5772 56.9869 16.5485 57.0149 16.5291 57.0337L16.5202 57.0424C15.4366 58.0742 13.7216 58.0327 12.6895 56.9488C11.6599 55.8675 11.6989 54.1578 12.7758 53.1249L35.6097 30.2911L45.501 40.1499L46.8661 41.5396L46.8708 41.5443L48.2666 42.9401L66.4679 61.1659C70.5735 65.2831 77.2399 65.2921 81.3572 61.1863C85.4737 57.0807 85.4829 50.4146 81.3772 46.2974L63.6646 28.6028L58.1462 34.1212L77.2299 53.205L77.2362 53.2116C78.2681 54.2953 78.2266 56.0102 77.1427 57.0423C76.0615 58.0719 74.3518 58.0329 73.3189 56.9561L50.4779 34.1213L63.6644 20.9348ZM35.2029 73.8775C37.1852 80.2642 42.6058 83.7792 44.9655 85.0399C47.3206 83.7787 52.7409 80.2637 54.7282 73.8775H35.2029ZM34.4563 68.4585H55.4755V61.0638H34.4563V68.4585ZM36.7646 55.6447H53.1619L44.9658 47.3276L36.7646 55.6447Z",
                                    fill: "#191818",
                                  },
                                }),
                              ]
                            ),
                          ]),
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "hex" }, [
                          _c(
                            "svg",
                            {
                              attrs: {
                                width: "204",
                                height: "185",
                                viewBox: "0 0 204 185",
                              },
                            },
                            [
                              _c("path", {
                                attrs: {
                                  opacity: ".1",
                                  d: "M192.657 65.3865C199.402 77.068 202.774 82.9088 203.44 89.2506C203.659 91.3354 203.659 93.4375 203.44 95.5223C202.774 101.864 199.402 107.705 192.657 119.386L170.63 157.538C163.886 169.22 160.514 175.061 155.355 178.809C153.659 180.041 151.838 181.092 149.923 181.945C144.098 184.538 137.353 184.538 123.865 184.538L79.8106 184.538C66.3219 184.538 59.5775 184.538 53.7521 181.945C51.837 181.092 50.0166 180.041 48.3206 178.809C43.1618 175.061 39.7896 169.22 33.0452 157.538L11.0182 119.386C4.2738 107.705 0.901622 101.864 0.235072 95.5223C0.015956 93.4375 0.0159561 91.3354 0.235072 89.2506C0.901622 82.9088 4.2738 77.068 11.0182 65.3865L33.0452 27.2345C39.7896 15.5529 43.1618 9.71208 48.3206 5.96396C50.0166 4.73178 51.837 3.68075 53.7521 2.8281C59.5775 0.234468 66.3219 0.234468 79.8106 0.234469L123.865 0.23447C137.353 0.234471 144.098 0.234471 149.923 2.82811C151.838 3.68076 153.659 4.73178 155.355 5.96396C160.514 9.71209 163.886 15.5529 170.63 27.2345L192.657 65.3865Z",
                                  fill: "url(#grt)",
                                },
                              }),
                            ]
                          ),
                        ]),
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "col" }, [
                        _c("div", { staticClass: "hex" }),
                        _vm._v(" "),
                        _c("div", { staticClass: "hex" }),
                        _vm._v(" "),
                        _c("div", { staticClass: "hex" }, [
                          _c(
                            "svg",
                            {
                              attrs: {
                                width: "204",
                                height: "185",
                                viewBox: "0 0 204 185",
                              },
                            },
                            [
                              _c("path", {
                                attrs: {
                                  opacity: ".12",
                                  d: "M192.657 65.3865C199.402 77.068 202.774 82.9088 203.44 89.2506C203.659 91.3354 203.659 93.4375 203.44 95.5223C202.774 101.864 199.402 107.705 192.657 119.386L170.63 157.538C163.886 169.22 160.514 175.061 155.355 178.809C153.659 180.041 151.838 181.092 149.923 181.945C144.098 184.538 137.353 184.538 123.865 184.538L79.8106 184.538C66.3219 184.538 59.5775 184.538 53.7521 181.945C51.837 181.092 50.0166 180.041 48.3206 178.809C43.1618 175.061 39.7896 169.22 33.0452 157.538L11.0182 119.386C4.2738 107.705 0.901622 101.864 0.235072 95.5223C0.015956 93.4375 0.0159561 91.3354 0.235072 89.2506C0.901622 82.9088 4.2738 77.068 11.0182 65.3865L33.0452 27.2345C39.7896 15.5529 43.1618 9.71208 48.3206 5.96396C50.0166 4.73178 51.837 3.68075 53.7521 2.8281C59.5775 0.234468 66.3219 0.234468 79.8106 0.234469L123.865 0.23447C137.353 0.234471 144.098 0.234471 149.923 2.82811C151.838 3.68076 153.659 4.73178 155.355 5.96396C160.514 9.71209 163.886 15.5529 170.63 27.2345L192.657 65.3865Z",
                                  fill: "url(#grt)",
                                },
                              }),
                            ]
                          ),
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "hex" }, [
                          _c(
                            "svg",
                            {
                              attrs: {
                                width: "204",
                                height: "185",
                                viewBox: "0 0 204 185",
                              },
                            },
                            [
                              _c("path", {
                                attrs: {
                                  opacity: ".09",
                                  d: "M192.657 65.3865C199.402 77.068 202.774 82.9088 203.44 89.2506C203.659 91.3354 203.659 93.4375 203.44 95.5223C202.774 101.864 199.402 107.705 192.657 119.386L170.63 157.538C163.886 169.22 160.514 175.061 155.355 178.809C153.659 180.041 151.838 181.092 149.923 181.945C144.098 184.538 137.353 184.538 123.865 184.538L79.8106 184.538C66.3219 184.538 59.5775 184.538 53.7521 181.945C51.837 181.092 50.0166 180.041 48.3206 178.809C43.1618 175.061 39.7896 169.22 33.0452 157.538L11.0182 119.386C4.2738 107.705 0.901622 101.864 0.235072 95.5223C0.015956 93.4375 0.0159561 91.3354 0.235072 89.2506C0.901622 82.9088 4.2738 77.068 11.0182 65.3865L33.0452 27.2345C39.7896 15.5529 43.1618 9.71208 48.3206 5.96396C50.0166 4.73178 51.837 3.68075 53.7521 2.8281C59.5775 0.234468 66.3219 0.234468 79.8106 0.234469L123.865 0.23447C137.353 0.234471 144.098 0.234471 149.923 2.82811C151.838 3.68076 153.659 4.73178 155.355 5.96396C160.514 9.71209 163.886 15.5529 170.63 27.2345L192.657 65.3865Z",
                                  fill: "url(#grt)",
                                },
                              }),
                            ]
                          ),
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "hex" }, [
                          _c(
                            "svg",
                            {
                              attrs: {
                                width: "204",
                                height: "185",
                                viewBox: "0 0 204 185",
                              },
                            },
                            [
                              _c("path", {
                                attrs: {
                                  opacity: ".03",
                                  d: "M192.657 65.3865C199.402 77.068 202.774 82.9088 203.44 89.2506C203.659 91.3354 203.659 93.4375 203.44 95.5223C202.774 101.864 199.402 107.705 192.657 119.386L170.63 157.538C163.886 169.22 160.514 175.061 155.355 178.809C153.659 180.041 151.838 181.092 149.923 181.945C144.098 184.538 137.353 184.538 123.865 184.538L79.8106 184.538C66.3219 184.538 59.5775 184.538 53.7521 181.945C51.837 181.092 50.0166 180.041 48.3206 178.809C43.1618 175.061 39.7896 169.22 33.0452 157.538L11.0182 119.386C4.2738 107.705 0.901622 101.864 0.235072 95.5223C0.015956 93.4375 0.0159561 91.3354 0.235072 89.2506C0.901622 82.9088 4.2738 77.068 11.0182 65.3865L33.0452 27.2345C39.7896 15.5529 43.1618 9.71208 48.3206 5.96396C50.0166 4.73178 51.837 3.68075 53.7521 2.8281C59.5775 0.234468 66.3219 0.234468 79.8106 0.234469L123.865 0.23447C137.353 0.234471 144.098 0.234471 149.923 2.82811C151.838 3.68076 153.659 4.73178 155.355 5.96396C160.514 9.71209 163.886 15.5529 170.63 27.2345L192.657 65.3865Z",
                                  fill: "url(#grt)",
                                },
                              }),
                            ]
                          ),
                        ]),
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "col" }, [
                        _c("div", { staticClass: "hex" }, [
                          _c(
                            "svg",
                            {
                              attrs: {
                                width: "204",
                                height: "185",
                                viewBox: "0 0 204 185",
                              },
                            },
                            [
                              _c("path", {
                                attrs: {
                                  opacity: ".03",
                                  d: "M192.657 65.3865C199.402 77.068 202.774 82.9088 203.44 89.2506C203.659 91.3354 203.659 93.4375 203.44 95.5223C202.774 101.864 199.402 107.705 192.657 119.386L170.63 157.538C163.886 169.22 160.514 175.061 155.355 178.809C153.659 180.041 151.838 181.092 149.923 181.945C144.098 184.538 137.353 184.538 123.865 184.538L79.8106 184.538C66.3219 184.538 59.5775 184.538 53.7521 181.945C51.837 181.092 50.0166 180.041 48.3206 178.809C43.1618 175.061 39.7896 169.22 33.0452 157.538L11.0182 119.386C4.2738 107.705 0.901622 101.864 0.235072 95.5223C0.015956 93.4375 0.0159561 91.3354 0.235072 89.2506C0.901622 82.9088 4.2738 77.068 11.0182 65.3865L33.0452 27.2345C39.7896 15.5529 43.1618 9.71208 48.3206 5.96396C50.0166 4.73178 51.837 3.68075 53.7521 2.8281C59.5775 0.234468 66.3219 0.234468 79.8106 0.234469L123.865 0.23447C137.353 0.234471 144.098 0.234471 149.923 2.82811C151.838 3.68076 153.659 4.73178 155.355 5.96396C160.514 9.71209 163.886 15.5529 170.63 27.2345L192.657 65.3865Z",
                                  fill: "url(#grt)",
                                },
                              }),
                            ]
                          ),
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "hex" }),
                        _vm._v(" "),
                        _c("div", { staticClass: "hex" }, [
                          _c(
                            "svg",
                            {
                              attrs: {
                                width: "204",
                                height: "185",
                                viewBox: "0 0 204 185",
                              },
                            },
                            [
                              _c("path", {
                                attrs: {
                                  opacity: ".03",
                                  d: "M192.657 65.3865C199.402 77.068 202.774 82.9088 203.44 89.2506C203.659 91.3354 203.659 93.4375 203.44 95.5223C202.774 101.864 199.402 107.705 192.657 119.386L170.63 157.538C163.886 169.22 160.514 175.061 155.355 178.809C153.659 180.041 151.838 181.092 149.923 181.945C144.098 184.538 137.353 184.538 123.865 184.538L79.8106 184.538C66.3219 184.538 59.5775 184.538 53.7521 181.945C51.837 181.092 50.0166 180.041 48.3206 178.809C43.1618 175.061 39.7896 169.22 33.0452 157.538L11.0182 119.386C4.2738 107.705 0.901622 101.864 0.235072 95.5223C0.015956 93.4375 0.0159561 91.3354 0.235072 89.2506C0.901622 82.9088 4.2738 77.068 11.0182 65.3865L33.0452 27.2345C39.7896 15.5529 43.1618 9.71208 48.3206 5.96396C50.0166 4.73178 51.837 3.68075 53.7521 2.8281C59.5775 0.234468 66.3219 0.234468 79.8106 0.234469L123.865 0.23447C137.353 0.234471 144.098 0.234471 149.923 2.82811C151.838 3.68076 153.659 4.73178 155.355 5.96396C160.514 9.71209 163.886 15.5529 170.63 27.2345L192.657 65.3865Z",
                                  fill: "url(#grt)",
                                },
                              }),
                            ]
                          ),
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "hex" }, [
                          _c(
                            "svg",
                            {
                              attrs: {
                                width: "204",
                                height: "185",
                                viewBox: "0 0 204 185",
                              },
                            },
                            [
                              _c("path", {
                                attrs: {
                                  opacity: ".05",
                                  d: "M192.657 65.3865C199.402 77.068 202.774 82.9088 203.44 89.2506C203.659 91.3354 203.659 93.4375 203.44 95.5223C202.774 101.864 199.402 107.705 192.657 119.386L170.63 157.538C163.886 169.22 160.514 175.061 155.355 178.809C153.659 180.041 151.838 181.092 149.923 181.945C144.098 184.538 137.353 184.538 123.865 184.538L79.8106 184.538C66.3219 184.538 59.5775 184.538 53.7521 181.945C51.837 181.092 50.0166 180.041 48.3206 178.809C43.1618 175.061 39.7896 169.22 33.0452 157.538L11.0182 119.386C4.2738 107.705 0.901622 101.864 0.235072 95.5223C0.015956 93.4375 0.0159561 91.3354 0.235072 89.2506C0.901622 82.9088 4.2738 77.068 11.0182 65.3865L33.0452 27.2345C39.7896 15.5529 43.1618 9.71208 48.3206 5.96396C50.0166 4.73178 51.837 3.68075 53.7521 2.8281C59.5775 0.234468 66.3219 0.234468 79.8106 0.234469L123.865 0.23447C137.353 0.234471 144.098 0.234471 149.923 2.82811C151.838 3.68076 153.659 4.73178 155.355 5.96396C160.514 9.71209 163.886 15.5529 170.63 27.2345L192.657 65.3865Z",
                                  fill: "url(#grt)",
                                },
                              }),
                            ]
                          ),
                        ]),
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "col" }, [
                        _c("div", { staticClass: "hex" }),
                        _vm._v(" "),
                        _c("div", { staticClass: "hex" }),
                        _vm._v(" "),
                        _c("div", { staticClass: "hex" }),
                        _vm._v(" "),
                        _c("div", { staticClass: "hex" }, [
                          _c(
                            "svg",
                            {
                              attrs: {
                                width: "204",
                                height: "185",
                                viewBox: "0 0 204 185",
                              },
                            },
                            [
                              _c("path", {
                                attrs: {
                                  opacity: ".05",
                                  d: "M192.657 65.3865C199.402 77.068 202.774 82.9088 203.44 89.2506C203.659 91.3354 203.659 93.4375 203.44 95.5223C202.774 101.864 199.402 107.705 192.657 119.386L170.63 157.538C163.886 169.22 160.514 175.061 155.355 178.809C153.659 180.041 151.838 181.092 149.923 181.945C144.098 184.538 137.353 184.538 123.865 184.538L79.8106 184.538C66.3219 184.538 59.5775 184.538 53.7521 181.945C51.837 181.092 50.0166 180.041 48.3206 178.809C43.1618 175.061 39.7896 169.22 33.0452 157.538L11.0182 119.386C4.2738 107.705 0.901622 101.864 0.235072 95.5223C0.015956 93.4375 0.0159561 91.3354 0.235072 89.2506C0.901622 82.9088 4.2738 77.068 11.0182 65.3865L33.0452 27.2345C39.7896 15.5529 43.1618 9.71208 48.3206 5.96396C50.0166 4.73178 51.837 3.68075 53.7521 2.8281C59.5775 0.234468 66.3219 0.234468 79.8106 0.234469L123.865 0.23447C137.353 0.234471 144.098 0.234471 149.923 2.82811C151.838 3.68076 153.659 4.73178 155.355 5.96396C160.514 9.71209 163.886 15.5529 170.63 27.2345L192.657 65.3865Z",
                                  fill: "url(#grt)",
                                },
                              }),
                            ]
                          ),
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "hex" }, [
                          _c(
                            "svg",
                            {
                              attrs: {
                                width: "204",
                                height: "185",
                                viewBox: "0 0 204 185",
                              },
                            },
                            [
                              _c("path", {
                                attrs: {
                                  opacity: ".05",
                                  d: "M192.657 65.3865C199.402 77.068 202.774 82.9088 203.44 89.2506C203.659 91.3354 203.659 93.4375 203.44 95.5223C202.774 101.864 199.402 107.705 192.657 119.386L170.63 157.538C163.886 169.22 160.514 175.061 155.355 178.809C153.659 180.041 151.838 181.092 149.923 181.945C144.098 184.538 137.353 184.538 123.865 184.538L79.8106 184.538C66.3219 184.538 59.5775 184.538 53.7521 181.945C51.837 181.092 50.0166 180.041 48.3206 178.809C43.1618 175.061 39.7896 169.22 33.0452 157.538L11.0182 119.386C4.2738 107.705 0.901622 101.864 0.235072 95.5223C0.015956 93.4375 0.0159561 91.3354 0.235072 89.2506C0.901622 82.9088 4.2738 77.068 11.0182 65.3865L33.0452 27.2345C39.7896 15.5529 43.1618 9.71208 48.3206 5.96396C50.0166 4.73178 51.837 3.68075 53.7521 2.8281C59.5775 0.234468 66.3219 0.234468 79.8106 0.234469L123.865 0.23447C137.353 0.234471 144.098 0.234471 149.923 2.82811C151.838 3.68076 153.659 4.73178 155.355 5.96396C160.514 9.71209 163.886 15.5529 170.63 27.2345L192.657 65.3865Z",
                                  fill: "url(#grt)",
                                },
                              }),
                            ]
                          ),
                        ]),
                      ]),
                    ]),
                  ]
                ),
              ]),
            ],
            1
          ),
          _vm._v(" "),
          _c("transition", { attrs: { name: "bee" } }, [
            _c(
              "div",
              {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.Global.currentConfigStep < 6,
                    expression: "Global.currentConfigStep < 6",
                  },
                ],
              },
              [
                _c(
                  "div",
                  {
                    staticClass: "preview",
                    class: [
                      _vm.Global.mockupConfig.activeNav ? "opdnv" : "",
                      _vm.Global.mockupConfig.topNav ? "tp" : "",
                      _vm.Global.mockupConfig.tempNoTrans ? "no-trans" : "",
                      _vm.Global.mockupConfig.verticalNav ? "vert" : "",
                      "radius" + _vm.Global.mockupConfig.radiusRatio,
                      _vm.Global.mockupConfig.activeFont,
                    ],
                  },
                  [
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: !_vm.Global.mockupConfig.topNav,
                            expression: "!Global.mockupConfig.topNav",
                          },
                        ],
                        staticClass: "nav hor",
                      },
                      [
                        _c("div", {
                          staticClass: "bg",
                          style: {
                            transform:
                              "translateX(" + -_vm.navCalcTrans + "px)",
                          },
                        }),
                        _vm._v(" "),
                        _c(
                          "div",
                          { ref: "navcontent", staticClass: "content" },
                          [
                            _c(
                              "div",
                              { ref: "name", staticClass: "company-logo" },
                              [
                                _vm.Global.mockupConfig.pictures.logo
                                  ? _c("span", { staticClass: "logo" }, [
                                      _c("img", {
                                        attrs: {
                                          src: _vm.Global.mockupConfig.pictures
                                            .logo,
                                          alt: "brand logo",
                                        },
                                      }),
                                    ])
                                  : _c("span", { staticClass: "ft-xbld" }, [
                                      _vm._v(
                                        _vm._s(
                                          _vm.Global.mockupConfig.infos
                                            .company || "Alpha Networks"
                                        )
                                      ),
                                    ]),
                              ]
                            ),
                            _vm._v(" "),
                            _c("div", { staticClass: "profile-wrapper" }, [
                              _c("div", { staticClass: "avatar" }, [
                                _c(
                                  "svg",
                                  {
                                    attrs: {
                                      width: "60",
                                      height: "60",
                                      viewBox: "0 0 60 60",
                                      fill: "none",
                                    },
                                  },
                                  [
                                    _c(
                                      "mask",
                                      {
                                        staticStyle: { "mask-type": "alpha" },
                                        attrs: {
                                          id: "mask0_85_5948",
                                          maskUnits: "userSpaceOnUse",
                                          x: "0",
                                          y: "0",
                                          width: "60",
                                          height: "60",
                                        },
                                      },
                                      [
                                        _c("rect", {
                                          attrs: {
                                            width: "60",
                                            height: "60",
                                            rx: "30",
                                            fill: "#F4F4F4",
                                          },
                                        }),
                                      ]
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "g",
                                      {
                                        attrs: { mask: "url(#mask0_85_5948)" },
                                      },
                                      [
                                        _c(
                                          "g",
                                          { attrs: { opacity: "0.15" } },
                                          [
                                            _c("rect", {
                                              attrs: {
                                                x: "-0.125",
                                                y: "-0.125",
                                                width: "60.25",
                                                height: "60.25",
                                                fill: "url(#paint2_linear_85_5948)",
                                              },
                                            }),
                                          ]
                                        ),
                                        _vm._v(" "),
                                        _c("path", {
                                          attrs: {
                                            "fill-rule": "evenodd",
                                            "clip-rule": "evenodd",
                                            d: "M39.8569 22.8571C39.8569 23.2545 39.8394 23.6756 39.8043 24.1148C40.3795 24.4083 40.7315 25.0603 40.5943 25.7463L40.0991 28.2225C39.9639 28.8985 39.3868 29.3918 38.7048 29.4264C37.9531 31.7044 36.8335 33.9315 35.346 35.5706L36.0789 41.0132C36.8045 41.1634 37.5259 41.3407 38.2416 41.5452L43.5714 43.068C49.1523 44.6625 53 49.7635 53 55.5678V66.5714H7V55.5678C7 49.7635 10.8477 44.6625 16.4286 43.068L21.7584 41.5452C22.4735 41.3409 23.1943 41.1637 23.9193 41.0136L24.6524 35.5695C23.1654 33.9305 22.0462 31.7039 21.2946 29.4264C20.6129 29.3916 20.0361 28.8983 19.9009 28.2225L19.4057 25.7463C19.2686 25.0605 19.6203 24.4087 20.1951 24.115C20.1601 23.6758 20.1426 23.2546 20.1426 22.8571C20.1426 17.4132 24.5558 13 29.9997 13C35.4437 13 39.8569 17.4132 39.8569 22.8571Z",
                                            fill: "url(#paint2_linear_85_5948)",
                                          },
                                        }),
                                        _vm._v(" "),
                                        _c("path", {
                                          attrs: {
                                            opacity: "0.2",
                                            "fill-rule": "evenodd",
                                            "clip-rule": "evenodd",
                                            d: "M24.6544 35.5693L23.4297 44.6644H36.5725L35.3479 35.5703C33.9097 37.1551 32.1277 38.1902 30.0017 38.1902C27.8752 38.1902 26.0928 37.1546 24.6544 35.5693Z",
                                            fill: "url(#paint3_linear_85_5948)",
                                          },
                                        }),
                                      ]
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "defs",
                                      [
                                        _c(
                                          "linearGradient",
                                          {
                                            attrs: {
                                              id: "paint2_linear_85_5948",
                                              x1: "15.4212",
                                              y1: "14.7416",
                                              x2: "48.1511",
                                              y2: "56.4838",
                                              gradientUnits: "userSpaceOnUse",
                                            },
                                          },
                                          [
                                            _c("stop", {
                                              attrs: {
                                                "stop-color":
                                                  _vm.Global.mockupConfig.colors
                                                    .icons,
                                              },
                                            }),
                                            _vm._v(" "),
                                            _c("stop", {
                                              attrs: {
                                                offset: "1",
                                                "stop-color": _vm.avatarGrt,
                                              },
                                            }),
                                          ],
                                          1
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "linearGradient",
                                          {
                                            attrs: {
                                              id: "paint3_linear_85_5948",
                                              x1: "30.0011",
                                              y1: "37.3472",
                                              x2: "30.0011",
                                              y2: "43.0233",
                                              gradientUnits: "userSpaceOnUse",
                                            },
                                          },
                                          [
                                            _c("stop"),
                                            _vm._v(" "),
                                            _c("stop", {
                                              attrs: {
                                                offset: "1",
                                                "stop-opacity": "0",
                                              },
                                            }),
                                          ],
                                          1
                                        ),
                                      ],
                                      1
                                    ),
                                  ]
                                ),
                              ]),
                              _vm._v(" "),
                              _c("div", { staticClass: "infos" }, [
                                _c(
                                  "span",
                                  {
                                    staticClass: "name ft-xbld",
                                    style: {
                                      color:
                                        _vm.Global.mockupConfig.colors.icons,
                                    },
                                  },
                                  [
                                    _vm._v(
                                      "\n                                " +
                                        _vm._s(
                                          _vm.Global.mockupConfig.infos.name ||
                                            "Jean-Maxime"
                                        ) +
                                        "\n                            "
                                    ),
                                  ]
                                ),
                                _vm._v(" "),
                                _c("span", { staticClass: "more" }, [
                                  _vm._v("Tap to access profile"),
                                ]),
                              ]),
                            ]),
                            _vm._v(" "),
                            _c("div", { staticClass: "nav-items ft-bld" }, [
                              _c("div", { staticClass: "item home" }, [
                                _c("span", { staticClass: "ico" }),
                                _vm._v(" "),
                                _c("span", { staticClass: "caption" }, [
                                  _vm._v("Home"),
                                ]),
                              ]),
                              _vm._v(" "),
                              _vm.Global.mockupConfig.content.vod
                                ? _c(
                                    "div",
                                    { key: "a", staticClass: "item demand" },
                                    [
                                      _c("span", { staticClass: "ico" }),
                                      _vm._v(" "),
                                      _c("span", { staticClass: "caption" }, [
                                        _vm._v("Video On Demand"),
                                      ]),
                                    ]
                                  )
                                : _vm._e(),
                              _vm._v(" "),
                              _vm.Global.mockupConfig.content.live
                                ? _c(
                                    "div",
                                    { key: "b", staticClass: "item live" },
                                    [
                                      _c("span", { staticClass: "ico" }),
                                      _vm._v(" "),
                                      _c("span", { staticClass: "caption" }, [
                                        _vm._v("Live 24x7"),
                                      ]),
                                    ]
                                  )
                                : _vm._e(),
                              _vm._v(" "),
                              _vm.Global.mockupConfig.content.events
                                ? _c(
                                    "div",
                                    { key: "c", staticClass: "item events" },
                                    [
                                      _c("span", { staticClass: "ico" }),
                                      _vm._v(" "),
                                      _c("span", { staticClass: "caption" }, [
                                        _vm._v("Live Events"),
                                      ]),
                                    ]
                                  )
                                : _vm._e(),
                              _vm._v(" "),
                              _vm.Global.mockupConfig.content.replay
                                ? _c(
                                    "div",
                                    { key: "d", staticClass: "item replay" },
                                    [
                                      _c("span", { staticClass: "ico" }),
                                      _vm._v(" "),
                                      _c("span", { staticClass: "caption" }, [
                                        _vm._v("Start Over & Replay"),
                                      ]),
                                    ]
                                  )
                                : _vm._e(),
                              _vm._v(" "),
                              _vm.Global.mockupConfig.content.podcast
                                ? _c(
                                    "div",
                                    { key: "e", staticClass: "item podcast" },
                                    [
                                      _c("span", { staticClass: "ico" }),
                                      _vm._v(" "),
                                      _c("span", { staticClass: "caption" }, [
                                        _vm._v("Podcast"),
                                      ]),
                                    ]
                                  )
                                : _vm._e(),
                              _vm._v(" "),
                              _c("div", { staticClass: "item fav" }, [
                                _c("span", { staticClass: "ico" }),
                                _vm._v(" "),
                                _c("span", { staticClass: "caption" }, [
                                  _vm._v("Favorite"),
                                ]),
                              ]),
                            ]),
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          {
                            staticClass: "expander",
                            style: {
                              transform:
                                "translateX(" + -_vm.navCalcTrans + "px)",
                              background: _vm.Global.mockupConfig.colors.icons,
                            },
                            on: {
                              click: function ($event) {
                                $event.preventDefault()
                                return _vm.toggleNav.apply(null, arguments)
                              },
                            },
                          },
                          [
                            _c("span", [
                              _c(
                                "svg",
                                {
                                  attrs: {
                                    width: "6",
                                    height: "10",
                                    viewBox: "0 0 8 14",
                                    fill: "none",
                                  },
                                },
                                [
                                  _c("path", {
                                    attrs: {
                                      d: "M1 1.5L6 7L1 12.5",
                                      stroke: "black",
                                      "stroke-width": "2.5",
                                    },
                                  }),
                                ]
                              ),
                            ]),
                          ]
                        ),
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.Global.mockupConfig.topNav,
                            expression: "Global.mockupConfig.topNav",
                          },
                        ],
                        staticClass: "nav tp",
                      },
                      [
                        _c("div", { staticClass: "bg" }),
                        _vm._v(" "),
                        _c("div", { staticClass: "content" }, [
                          _c("div", { staticClass: "avatar" }, [
                            _c(
                              "svg",
                              {
                                attrs: {
                                  width: "60",
                                  height: "60",
                                  viewBox: "0 0 60 60",
                                  fill: "none",
                                },
                              },
                              [
                                _c(
                                  "mask",
                                  {
                                    staticStyle: { "mask-type": "alpha" },
                                    attrs: {
                                      id: "mask",
                                      maskUnits: "userSpaceOnUse",
                                      x: "0",
                                      y: "0",
                                      width: "60",
                                      height: "60",
                                    },
                                  },
                                  [
                                    _c("rect", {
                                      attrs: {
                                        width: "60",
                                        height: "60",
                                        rx: "30",
                                        fill: "#F4F4F4",
                                      },
                                    }),
                                  ]
                                ),
                                _vm._v(" "),
                                _c("g", { attrs: { mask: "url(#mask)" } }, [
                                  _c("g", { attrs: { opacity: "0.15" } }, [
                                    _c("rect", {
                                      attrs: {
                                        x: "-0.125",
                                        y: "-0.125",
                                        width: "60.25",
                                        height: "60.25",
                                        fill: "url(#mask2)",
                                      },
                                    }),
                                  ]),
                                  _vm._v(" "),
                                  _c("path", {
                                    attrs: {
                                      "fill-rule": "evenodd",
                                      "clip-rule": "evenodd",
                                      d: "M39.8569 22.8571C39.8569 23.2545 39.8394 23.6756 39.8043 24.1148C40.3795 24.4083 40.7315 25.0603 40.5943 25.7463L40.0991 28.2225C39.9639 28.8985 39.3868 29.3918 38.7048 29.4264C37.9531 31.7044 36.8335 33.9315 35.346 35.5706L36.0789 41.0132C36.8045 41.1634 37.5259 41.3407 38.2416 41.5452L43.5714 43.068C49.1523 44.6625 53 49.7635 53 55.5678V66.5714H7V55.5678C7 49.7635 10.8477 44.6625 16.4286 43.068L21.7584 41.5452C22.4735 41.3409 23.1943 41.1637 23.9193 41.0136L24.6524 35.5695C23.1654 33.9305 22.0462 31.7039 21.2946 29.4264C20.6129 29.3916 20.0361 28.8983 19.9009 28.2225L19.4057 25.7463C19.2686 25.0605 19.6203 24.4087 20.1951 24.115C20.1601 23.6758 20.1426 23.2546 20.1426 22.8571C20.1426 17.4132 24.5558 13 29.9997 13C35.4437 13 39.8569 17.4132 39.8569 22.8571Z",
                                      fill: "url(#mask2)",
                                    },
                                  }),
                                  _vm._v(" "),
                                  _c("path", {
                                    attrs: {
                                      opacity: "0.2",
                                      "fill-rule": "evenodd",
                                      "clip-rule": "evenodd",
                                      d: "M24.6544 35.5693L23.4297 44.6644H36.5725L35.3479 35.5703C33.9097 37.1551 32.1277 38.1902 30.0017 38.1902C27.8752 38.1902 26.0928 37.1546 24.6544 35.5693Z",
                                      fill: "url(#mask3)",
                                    },
                                  }),
                                ]),
                                _vm._v(" "),
                                _c(
                                  "defs",
                                  [
                                    _c(
                                      "linearGradient",
                                      {
                                        attrs: {
                                          id: "mask2",
                                          x1: "15.4212",
                                          y1: "14.7416",
                                          x2: "48.1511",
                                          y2: "56.4838",
                                          gradientUnits: "userSpaceOnUse",
                                        },
                                      },
                                      [
                                        _c("stop", {
                                          attrs: {
                                            "stop-color":
                                              _vm.Global.mockupConfig.colors
                                                .icons,
                                          },
                                        }),
                                        _vm._v(" "),
                                        _c("stop", {
                                          attrs: {
                                            offset: "1",
                                            "stop-color": _vm.avatarGrt,
                                          },
                                        }),
                                      ],
                                      1
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "linearGradient",
                                      {
                                        attrs: {
                                          id: "mask3",
                                          x1: "30.0011",
                                          y1: "37.3472",
                                          x2: "30.0011",
                                          y2: "43.0233",
                                          gradientUnits: "userSpaceOnUse",
                                        },
                                      },
                                      [
                                        _c("stop"),
                                        _vm._v(" "),
                                        _c("stop", {
                                          attrs: {
                                            offset: "1",
                                            "stop-opacity": "0",
                                          },
                                        }),
                                      ],
                                      1
                                    ),
                                  ],
                                  1
                                ),
                              ]
                            ),
                          ]),
                          _vm._v(" "),
                          _c("div", { staticClass: "company-logo" }, [
                            _vm.Global.mockupConfig.pictures.logo
                              ? _c("span", { staticClass: "logo" }, [
                                  _c("img", {
                                    attrs: {
                                      src: _vm.Global.mockupConfig.pictures
                                        .logo,
                                      alt: "brand logo",
                                    },
                                  }),
                                ])
                              : _c("span", { staticClass: "ft-xbld" }, [
                                  _vm._v(
                                    _vm._s(
                                      _vm.Global.mockupConfig.infos.company ||
                                        "Alpha Networks"
                                    )
                                  ),
                                ]),
                          ]),
                          _vm._v(" "),
                          _c("div", { staticClass: "nav-items ft-bld" }, [
                            _c("div", { staticClass: "item home" }, [
                              _c("span", { staticClass: "ico" }),
                            ]),
                            _vm._v(" "),
                            _vm.Global.mockupConfig.content.vod
                              ? _c(
                                  "div",
                                  { key: "a", staticClass: "item demand" },
                                  [_c("span", { staticClass: "ico" })]
                                )
                              : _vm._e(),
                            _vm._v(" "),
                            _vm.Global.mockupConfig.content.live
                              ? _c(
                                  "div",
                                  { key: "b", staticClass: "item live" },
                                  [_c("span", { staticClass: "ico" })]
                                )
                              : _vm._e(),
                            _vm._v(" "),
                            _vm.Global.mockupConfig.content.events
                              ? _c(
                                  "div",
                                  { key: "c", staticClass: "item events" },
                                  [_c("span", { staticClass: "ico" })]
                                )
                              : _vm._e(),
                            _vm._v(" "),
                            _vm.Global.mockupConfig.content.replay
                              ? _c(
                                  "div",
                                  { key: "d", staticClass: "item replay" },
                                  [_c("span", { staticClass: "ico" })]
                                )
                              : _vm._e(),
                            _vm._v(" "),
                            _vm.Global.mockupConfig.content.podcast
                              ? _c(
                                  "div",
                                  { key: "e", staticClass: "item podcast" },
                                  [_c("span", { staticClass: "ico" })]
                                )
                              : _vm._e(),
                            _vm._v(" "),
                            _c("div", { staticClass: "item fav" }, [
                              _c("span", { staticClass: "ico" }),
                            ]),
                          ]),
                          _vm._v(" "),
                          _c("div", { staticClass: "profile" }),
                        ]),
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        staticClass: "main",
                        style: {
                          transform: "translateX(" + -_vm.navCalcTrans + "px)",
                        },
                      },
                      [
                        !_vm.Global.mockupConfig.pictures.background
                          ? _c("div", {
                              staticClass: "back-bg cvr",
                              style: _vm.bgGrt,
                            })
                          : _c("div", {
                              staticClass: "back-bg cvr w-img",
                              style: {
                                backgroundImage:
                                  "url(" +
                                  _vm.Global.mockupConfig.pictures.background +
                                  ")",
                              },
                            }),
                        _vm._v(" "),
                        _c("div", { staticClass: "head" }, [
                          _c("div", { staticClass: "fake-blocks" }, [
                            _c("span", { staticClass: "big" }),
                            _vm._v(" "),
                            _c("span", { staticClass: "slim one" }),
                            _vm._v(" "),
                            _c("div", { staticClass: "mult" }, [
                              _c("span", { staticClass: "slim two" }),
                              _vm._v(" "),
                              _c("span", { staticClass: "slim three" }),
                            ]),
                            _vm._v(" "),
                            _c("span", { staticClass: "slim four" }),
                          ]),
                          _vm._v(" "),
                          _c("div", { staticClass: "actions-wrapper" }, [
                            _c("div", { staticClass: "fake-btn info" }, [
                              _c("span", { staticClass: "icon" }),
                            ]),
                            _vm._v(" "),
                            !_vm.firstButton
                              ? _c(
                                  "div",
                                  {
                                    staticClass: "fake-btn ply",
                                    style: {
                                      background:
                                        _vm.Global.mockupConfig.colors.icons,
                                    },
                                  },
                                  [_c("span", { staticClass: "icon" })]
                                )
                              : _c(
                                  "div",
                                  {
                                    staticClass: "fake-btn ply ply-cap",
                                    style: {
                                      background:
                                        _vm.Global.mockupConfig.colors.icons,
                                    },
                                  },
                                  [
                                    _c("div", { staticClass: "in" }, [
                                      _c("span", { staticClass: "icon" }),
                                      _vm._v(" "),
                                      _c(
                                        "span",
                                        { staticClass: "txt ft-xbld txt-blk" },
                                        [_vm._v(_vm._s(_vm.firstButton))]
                                      ),
                                    ]),
                                  ]
                                ),
                          ]),
                        ]),
                        _vm._v(" "),
                        _c(
                          "div",
                          { staticClass: "cat-listing" },
                          _vm._l(_vm.rails, function (rail, railIndex) {
                            return _c(
                              "div",
                              { key: railIndex, staticClass: "cat-wrapper" },
                              [
                                _c(
                                  "span",
                                  { staticClass: "cat-title ft-xbld" },
                                  [_vm._v(_vm._s(rail.label))]
                                ),
                                _vm._v(" "),
                                _c("div", { staticClass: "card-wrapper" }, [
                                  _c(
                                    "div",
                                    {
                                      staticClass: "card",
                                      style: {
                                        backgroundColor:
                                          _vm.Global.mockupConfig.colors.icons,
                                      },
                                    },
                                    [
                                      _c(
                                        "div",
                                        {
                                          staticClass: "free-tag",
                                          style: {
                                            opacity: _vm.freeButton ? 1 : 0,
                                            background:
                                              _vm.Global.mockupConfig.colors
                                                .icons,
                                          },
                                        },
                                        [
                                          _c(
                                            "span",
                                            {
                                              staticClass:
                                                "ft-xbld txt txt-blk",
                                            },
                                            [_vm._v("Play free")]
                                          ),
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _c("div", { staticClass: "fake-info" }, [
                                        _c("span", { staticClass: "big" }),
                                        _vm._v(" "),
                                        _c("div", { staticClass: "progress" }, [
                                          _c("span"),
                                        ]),
                                      ]),
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    {
                                      staticClass: "card",
                                      style: {
                                        backgroundColor:
                                          _vm.Global.mockupConfig.colors.icons,
                                      },
                                    },
                                    [
                                      _c(
                                        "div",
                                        {
                                          staticClass: "free-tag",
                                          style: {
                                            opacity: _vm.freeButton ? 1 : 0,
                                            background:
                                              _vm.Global.mockupConfig.colors
                                                .icons,
                                          },
                                        },
                                        [
                                          _c(
                                            "span",
                                            {
                                              staticClass:
                                                "ft-xbld txt txt-blk",
                                            },
                                            [_vm._v("Play free")]
                                          ),
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _c("div", { staticClass: "fake-info" }, [
                                        _c("span", { staticClass: "big" }),
                                        _vm._v(" "),
                                        _c("div", { staticClass: "progress" }, [
                                          _c("span"),
                                        ]),
                                      ]),
                                    ]
                                  ),
                                  _vm._v(" "),
                                  railIndex === 0
                                    ? _c(
                                        "div",
                                        {
                                          staticClass: "card",
                                          style: {
                                            backgroundColor:
                                              _vm.Global.mockupConfig.colors
                                                .icons,
                                          },
                                        },
                                        [
                                          _c(
                                            "div",
                                            { staticClass: "fake-info" },
                                            [
                                              _c("span", {
                                                staticClass: "big",
                                              }),
                                              _vm._v(" "),
                                              _c(
                                                "div",
                                                { staticClass: "progress" },
                                                [_c("span")]
                                              ),
                                            ]
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "div",
                                            {
                                              staticClass: "hvr-preview",
                                              class: {
                                                active:
                                                  _vm.Global
                                                    .currentConfigStep != 2,
                                              },
                                            },
                                            [
                                              _c(
                                                "div",
                                                {
                                                  staticClass: "top",
                                                  style: {
                                                    backgroundColor:
                                                      _vm.Global.mockupConfig
                                                        .colors.icons,
                                                  },
                                                },
                                                [
                                                  _c(
                                                    "div",
                                                    {
                                                      staticClass: "fake-info",
                                                    },
                                                    [
                                                      _c("span", {
                                                        staticClass: "big",
                                                      }),
                                                      _vm._v(" "),
                                                      _c(
                                                        "div",
                                                        {
                                                          staticClass:
                                                            "progress",
                                                        },
                                                        [_c("span")]
                                                      ),
                                                    ]
                                                  ),
                                                ]
                                              ),
                                              _vm._v(" "),
                                              _c(
                                                "div",
                                                { staticClass: "btm" },
                                                [
                                                  _c(
                                                    "div",
                                                    {
                                                      staticClass:
                                                        "fake-blocks",
                                                    },
                                                    [
                                                      _c("span", {
                                                        staticClass: "slim one",
                                                      }),
                                                      _vm._v(" "),
                                                      _c(
                                                        "div",
                                                        { staticClass: "mult" },
                                                        [
                                                          _c("span", {
                                                            staticClass:
                                                              "slim two",
                                                          }),
                                                          _vm._v(" "),
                                                          _c("span", {
                                                            staticClass:
                                                              "slim three",
                                                          }),
                                                        ]
                                                      ),
                                                      _vm._v(" "),
                                                      _c("span", {
                                                        staticClass:
                                                          "slim four",
                                                      }),
                                                    ]
                                                  ),
                                                  _vm._v(" "),
                                                  _c(
                                                    "div",
                                                    {
                                                      staticClass:
                                                        "actions-wrapper",
                                                    },
                                                    [
                                                      _c(
                                                        "div",
                                                        {
                                                          staticClass:
                                                            "fake-btn info",
                                                        },
                                                        [
                                                          _c("span", {
                                                            staticClass: "icon",
                                                          }),
                                                        ]
                                                      ),
                                                      _vm._v(" "),
                                                      !_vm.secondButton
                                                        ? _c(
                                                            "div",
                                                            {
                                                              staticClass:
                                                                "fake-btn ply",
                                                              style: {
                                                                background:
                                                                  _vm.Global
                                                                    .mockupConfig
                                                                    .colors
                                                                    .icons,
                                                              },
                                                            },
                                                            [
                                                              _c("span", {
                                                                staticClass:
                                                                  "icon",
                                                              }),
                                                            ]
                                                          )
                                                        : _c(
                                                            "div",
                                                            {
                                                              staticClass:
                                                                "fake-btn ply ply-cap",
                                                              style: {
                                                                background:
                                                                  _vm.Global
                                                                    .mockupConfig
                                                                    .colors
                                                                    .icons,
                                                              },
                                                            },
                                                            [
                                                              _c(
                                                                "div",
                                                                {
                                                                  staticClass:
                                                                    "in",
                                                                },
                                                                [
                                                                  _c("span", {
                                                                    staticClass:
                                                                      "icon",
                                                                  }),
                                                                  _vm._v(" "),
                                                                  _c(
                                                                    "span",
                                                                    {
                                                                      staticClass:
                                                                        "txt ft-xbld txt-blk",
                                                                    },
                                                                    [
                                                                      _vm._v(
                                                                        _vm._s(
                                                                          _vm.secondButton
                                                                        )
                                                                      ),
                                                                    ]
                                                                  ),
                                                                ]
                                                              ),
                                                            ]
                                                          ),
                                                    ]
                                                  ),
                                                ]
                                              ),
                                            ]
                                          ),
                                        ]
                                      )
                                    : _c(
                                        "div",
                                        {
                                          staticClass: "card",
                                          style: {
                                            backgroundColor:
                                              _vm.Global.mockupConfig.colors
                                                .icons,
                                          },
                                        },
                                        [
                                          _c(
                                            "div",
                                            { staticClass: "fake-info" },
                                            [
                                              _c("span", {
                                                staticClass: "big",
                                              }),
                                              _vm._v(" "),
                                              _c(
                                                "div",
                                                { staticClass: "progress" },
                                                [_c("span")]
                                              ),
                                            ]
                                          ),
                                        ]
                                      ),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    {
                                      staticClass: "card",
                                      style: {
                                        backgroundColor:
                                          _vm.Global.mockupConfig.colors.icons,
                                      },
                                    },
                                    [
                                      _c("div", { staticClass: "fake-info" }, [
                                        _c("span", { staticClass: "big" }),
                                        _vm._v(" "),
                                        _c("div", { staticClass: "progress" }, [
                                          _c("span"),
                                        ]),
                                      ]),
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    {
                                      staticClass: "card",
                                      style: {
                                        backgroundColor:
                                          _vm.Global.mockupConfig.colors.icons,
                                      },
                                    },
                                    [
                                      _c("div", { staticClass: "fake-info" }, [
                                        _c("span", { staticClass: "big" }),
                                        _vm._v(" "),
                                        _c("div", { staticClass: "progress" }, [
                                          _c("span"),
                                        ]),
                                      ]),
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    {
                                      staticClass: "card",
                                      style: {
                                        backgroundColor:
                                          _vm.Global.mockupConfig.colors.icons,
                                      },
                                    },
                                    [
                                      _c("div", { staticClass: "fake-info" }, [
                                        _c("span", { staticClass: "big" }),
                                        _vm._v(" "),
                                        _c("div", { staticClass: "progress" }, [
                                          _c("span"),
                                        ]),
                                      ]),
                                    ]
                                  ),
                                ]),
                              ]
                            )
                          }),
                          0
                        ),
                      ]
                    ),
                  ]
                ),
              ]
            ),
          ]),
        ],
        1
      ),
      _vm._v(" "),
      _vm.Global.windowWidth < 1025
        ? _c(
            "div",
            { staticClass: "resp-mess" },
            [
              _c("span", { staticClass: "caption ft-xbld txt-grt" }, [
                _vm._v("Hey there !"),
              ]),
              _vm._v(" "),
              _c("p", [
                _vm._v(
                  "Lorem ipsum dolor sit amet consectetur adipisicing elit. Accusamus quaerat unde, soluta ex veniam."
                ),
              ]),
              _vm._v(" "),
              _c(
                "router-link",
                { staticClass: "btn main lrg", attrs: { tag: "a", to: "/" } },
                [
                  _c("span", { staticClass: "txt" }, [
                    _vm._v("Back to homepage"),
                  ]),
                ]
              ),
            ],
            1
          )
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }